import React, { useState, useEffect, useRef } from 'react'
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
// import SpinnerLoader from 'src/app/components/commonComponents/SpinnerLoader';
// import { performAccountValidation, sendVerificationCode } from '@parent-app/services';
// import { ErrorType } from '@parent-app/types';
// import { isValidEmail } from '@parent-app/utils';
// import { LOGIN_OTP_TYPE } from '@parent-app/config';
import { performAccountValidation, sendVerificationCode } from '../../../shared/services/src/index';
import { ErrorType } from '../../../shared/types/src/index';
import { isValidEmail } from '../../../shared/utils/src/index';
import { APP_MESSAGES, LOGIN_OTP_TYPE } from '../../../shared/config/src/index';
import Footer from 'src/app/components/commonComponents/Footer';
import Images from '../../static';
import CustomButton from 'src/app/components/commonComponents/CustomButton';
import CustomTextInput from 'src/app/components/commonComponents/CustomTextInput';
import DownloadAppComponent from 'src/app/components/commonComponents/DownloadAppComponent';
import { AppRoutes } from 'src/app/navigation/routes';
import { URL_CONSTANTS } from 'src/app/config/appConstants';
import { getRedirectionRoute } from 'src/app/utilities/helpers';
import { usePreviousRoute } from 'src/app/guards/PreviousRouteContext';

const FIELD_MAP = {
  EMAIL: 'email'
};

const apiErrorMap: { [key: string]: string } = {
  "email": FIELD_MAP.EMAIL
}

const VerifyEmailScreen = () => {

  const navigate = useNavigate()
  const { previousRoute, emailFromUrl, emailSetter } = usePreviousRoute();
  const inputRef: any = useRef(null);
  const buttonRef: any = useRef(null);

  const [email, setEmail] = useState<string>(emailFromUrl);
  const [errors, setErrors] = useState<ErrorType>({});
  const [isVerifying, setIsVerifying] = useState<boolean>(false);
  const [redirectionRoute, setRedirectionRoute] = useState<string>();

  useEffect(() => {
    setEmail(emailFromUrl)
  }, [emailFromUrl])

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
    if(previousRoute && previousRoute.includes('deep-link')) {
      const token = previousRoute.split('/')[2]
      const payload = JSON.parse(atob(token));
      if (payload?.eventType === 'ACCOUNT_ACTIVATION') {
        emailSetter(payload?.email || '')
        navigate(AppRoutes.MOBILE_APP_LANDSCAPE_VIEW);
        return;
      }
    }

    const redirectTo = getRedirectionRoute(previousRoute);
    const verifyEmailRouteWithRedirection = `${AppRoutes.VERIFY_EMAIL}${redirectTo ? `?${URL_CONSTANTS.REDIRECT_TO}=${redirectTo}` : ''}`

    if (redirectTo) {
      navigate(verifyEmailRouteWithRedirection);
      setRedirectionRoute(redirectTo);
    }
  }, []);

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter' && buttonRef.current) {
      buttonRef.current.click();
    }
  };

  const handleEmailInput = (e: any) => {
    setEmail(e.target.value)
    let errorObj: ErrorType = errors;
    errorObj = {
      ...errorObj,
      [FIELD_MAP.EMAIL]: {
        isErrored: false,
        errorMsg: ``,
      },
    }
    setErrors(errorObj); 
  }

  const runValidations = () => {
    let errorObj: ErrorType = {};
    if (!email) {
      errorObj = {
        ...errorObj,
        [FIELD_MAP.EMAIL]: {
          isErrored: true,
          errorMsg: `Email cannot be blank`,
        },
      };
    } else if (!isValidEmail(email)) {
      errorObj = {
        ...errorObj,
        [FIELD_MAP.EMAIL]: {
          isErrored: true,
          errorMsg: `Email is invalid`,
        },
      };
    }
    setErrors(errorObj);

    if (Object.keys(errorObj).length) return false;
    else return true;
  }

  const handleVerifyEmail = async () => {

    if (isVerifying) return;

    let validity = runValidations();
    if (!validity) return;

    try {
      setErrors({});
      setIsVerifying(true);
      const { accountActive } = await performAccountValidation({ email });
      if (accountActive) {
        navigate(`${AppRoutes.LOGIN}${redirectionRoute ? `?${URL_CONSTANTS.REDIRECT_TO}=${redirectionRoute}` : ''}`, {state: {email, isAccountActive: true}});
      } else {
        await handleAccountVerification(email);
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        const apiError = error as AxiosError;
        if (apiError && apiError.response && apiError.response.status === 404) {
          const { errors } = error.response?.data;
          toast.error(errors.join(", "), { autoClose: 5000 })
        } else if (apiError && apiError.response && apiError.response.status === 400) {
          const { validation_errors, errors } = error.response?.data;
          let errorObj: ErrorType = {};
          if (validation_errors && Object.keys(validation_errors).length > 0) {
            for (let [key, value] of Object.entries(validation_errors)) {
              errorObj = {
                ...errorObj,
                [apiErrorMap[key]]: {
                  isErrored: true,
                  errorMsg: (value as any[]).length > 1 ? (value as any[]).join(",") : (value as any[])[0]
                }
              }
            }
            setErrors(errorObj);
          } else if (errors && Object.keys(errors).length > 0) {
            toast.error(errors.join(", "), { autoClose: 5000 })
          }
        } else {
          toast.error(APP_MESSAGES.generalErrorMessage, { autoClose: 5000 })
        }
      }
    } finally {
      setIsVerifying(false);
    }
  }

  const handleAccountVerification = async (email: string) => {
    try {
      const { sessionId } = await sendVerificationCode({ email, type: LOGIN_OTP_TYPE.ACTIVATION });
      if (sessionId) {
        navigate(`${AppRoutes.VERIFY_OTP}${redirectionRoute ? `?${URL_CONSTANTS.REDIRECT_TO}=${redirectionRoute}` : ''}`, { state: { sessionId, email } })
      } else {
        toast.error(APP_MESSAGES.generalErrorMessage, { autoClose: 5000 })
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        const apiError = error as AxiosError;
        if (apiError && apiError.response) {
          const { errors } = error.response?.data;
          toast.error(errors.join(", "), { autoClose: 5000 });
        } else {
          toast.error(APP_MESSAGES.generalErrorMessage, { autoClose: 5000 });
        }
      }
    }
  }

  return (
    <div className='main-wrapper bg-white container'>
      <div className='d-flex flex-column flex-grow-1 mg-b-20'>
        <div className='mg-b-78 mg-t-xxl-100 mg-t-xs-50 pd-t-md-30 pd-t-xs-0 d-flex justify-content-center align-items-center'>
          <img src={Images.logo} alt="logo" className="eyworks-logo" />
        </div>
        <p className='fs-4 text-black fw-bold'>Sign In</p>
        <p className='fs-14 text-black mg-b-28'>Please enter your email and tap ‘Next’.</p>
        <div className='mg-b-25'>
          <CustomTextInput
            type={'email'}
            name={'email'}
            value={email}
            onChange={handleEmailInput}
            label={'Email'}
            inputRef={inputRef}
            handleKeyDown={handleKeyDown}
          />
          {errors && errors[FIELD_MAP.EMAIL] && errors[FIELD_MAP.EMAIL].isErrored ? <span className="form-error">{errors[FIELD_MAP.EMAIL].errorMsg}</span>: null}
        </div>
        <CustomButton buttonRef={buttonRef} text={'Next'} onClick={handleVerifyEmail} isLoading={isVerifying} color={'primary'} />
      </div>
      <div className='mg-b-10'>
        <DownloadAppComponent />
        <Footer />
      </div>
    </div>
  )
}

export default VerifyEmailScreen;